/* eslint-disable max-len */
import React from 'react';

const HeightIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" fill="currentColor" {...props}>
    <path d="M10 7.3V5.53l1.53 1.57a.2.2 0 0 0 .28 0l.37-.37a.2.2 0 0 0 0-.28L9.5 3.76 6.81 6.45a.2.2 0 0 0 0 .28l.37.37a.2.2 0 0 0 .28 0L9 5.53v7.93L7.47 11.9a.2.2 0 0 0-.28 0l-.37.37a.2.2 0 0 0 0 .28l2.68 2.69 2.69-2.69a.2.2 0 0 0 0-.28l-.37-.37a.2.2 0 0 0-.28 0L10 13.46V7.3zM2 17h15v1H2zM2 1h15v1H2z" />
  </svg>
);

export default HeightIcon;
